var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    className: "fill-selector",
    fill: "#2248C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.304 13.512L10.144 11.304C12.4 10.632 12.896 9.88 12.896 8.84C12.896 7.912 12.192 7.464 11.264 7.464C10.368 7.464 9.696 7.672 8.672 8.072V6.344C9.232 6.04 10.192 5.672 11.36 5.672C13.552 5.672 15.152 6.664 15.152 8.792C15.152 10.744 14.08 11.48 12.096 12.184L11.968 13.512H10.304ZM9.936 15.992C9.936 15.336 10.48 14.776 11.136 14.776C11.792 14.776 12.32 15.336 12.32 15.992C12.32 16.648 11.792 17.16 11.136 17.16C10.48 17.16 9.936 16.648 9.936 15.992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.f1c98981369b81d996da765809ced7fe.svg";
export { ForwardRef as ReactComponent };